// extracted by mini-css-extract-plugin
module.exports = {"root":"CollapseControls_root__35Qpr","btn":"CollapseControls_btn__WGT3K"};